import React, { Component } from 'react'
import { Card, Button, Radio } from 'hljd'
import { inject, observer } from 'mobx-react'
import SpreadModal from '../../SpreadModal'
import {
  VIDEO_LIVING,
  VIDEO_COMING,
  MERCHANT_NO_SPREAD,
  OPERATE_NO_SPREAD
} from '../constant'
import Style from './style.module.less'

@inject('store')
@observer
export default class extends Component {
  render() {
    const {
      store: {
        endVideo,
        spreadModal,
        id,
        onChangeSpreadModal,
        changeLiveLine,
        detail,
        liveStatus,
        detail: { fromType, liveLine }
      }
    } = this.props
    console.log(liveLine)
    return (
      <Card title="操作台">
        <div className={Style.operation}>
          <Button
            className={Style.mr20}
            onClick={endVideo}
            disabled={VIDEO_LIVING != liveStatus}
          >
            结束直播
          </Button>
          {/* 直播中&非推广 不显示增加推广时间*/}
          {!(
            VIDEO_LIVING == liveStatus &&
            (fromType == MERCHANT_NO_SPREAD || fromType == OPERATE_NO_SPREAD)
          ) && (
            <Button
              type="primary"
              onClick={onChangeSpreadModal}
              disabled={
                VIDEO_LIVING != liveStatus && VIDEO_COMING != liveStatus
              }
            >
              增加推广时长
            </Button>
          )}
        </div>
        {VIDEO_LIVING == liveStatus && (
          <div className={Style.line}>
            <p>
              <p style={{ marginBottom: 0, fontSize: 16 }}>
                <strong>直播线路:</strong>
              </p>
              <span style={{ color: '#999999' }}>
                直播过程中若画面出现卡顿, 可切换线路调整
              </span>
            </p>
            <Radio.Group value={liveLine} onChange={changeLiveLine}>
              <Radio value={1}>线路一</Radio>
              <Radio value={2}>线路二</Radio>
            </Radio.Group>
          </div>
        )}
        <SpreadModal
          visible={spreadModal}
          onCancel={onChangeSpreadModal}
          onOk={onChangeSpreadModal}
          current={{
            id,
            start_time: detail.startTime,
            fromType
          }}
        />
      </Card>
    )
  }
}
